import useVerticalRoutes from './pages';

const useNavigation = () => {
   const pages = useVerticalRoutes();
   const navigation = [...pages];
   return navigation;
};

export default useNavigation;
